module.exports = __webpack_public_path__ + "img/02.6ac7a8d2.jpg";